import { render, staticRenderFns } from "./auth-form-register.vue?vue&type=template&id=776e241a&scoped=true"
import script from "./auth-form-register.vue?vue&type=script&lang=js"
export * from "./auth-form-register.vue?vue&type=script&lang=js"
import style0 from "./auth-form-register.vue?vue&type=style&index=0&id=776e241a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776e241a",
  null
  
)

export default component.exports